import { WIDGETS } from "./widgets";
import { ValueOfObjectFields } from "shared/lib/interfaces/utils";

const NETWORK_CATEGORY = "NETWORK";

const WEBSOCKETS_CATEGORY = "WEBSOCKETS";
const LIST_DIALING_SUBCATEGORY = "LIST_DIALING";
const NOTIFICATIONS_SUBCATEGORY = "NOTIFICATIONS";

const CALLING_MODULE_CATEGORY = "CALLING_MODULE";
const FREQUENTLY_CHANGING_CONTEXT_SUBCATEGORY = "FREQUENTLY_CHANGING_CONTEXT";

const DIALER_TOUR = "DIALER_TOUR";

const MESSAGING_MODULE_CATEGORY = "MESSAGING";

const WIDGETS_CATEGORY = "WIDGETS";

const ACCOUNT_CATEGORY = "ACCOUNT_DETAILS";

const ACCOUNT_HISTORY_SUBCATEGORY = "HISTORY";

const DISPOSITION_SUBCATEGORY = "DISPOSITION";

const LIST_DIALING_CATEGORY = "LIST_DIALING";

const CALL_COPILOT_SUBCATEGORY = "CALL_COPILOT";

const EMAIL_TEMPLATES_SUBCATEGORY = "EMAIL_TEMPLATES";

const LIST_WORKSPACE_CATEGORY = "LIST_WORKSPACE";
const TABLE_SUBCATEGORY = "TABLE";

export const CUSTOM_EVENTS = {
  // TODO - better struction for events
  MEETING: "meeting",
  // ---------------------------------

  NETWORK: {
    ONLINE: `${NETWORK_CATEGORY}:ONLINE`,
    OFFLINE: `${NETWORK_CATEGORY}:OFFLINE`,
  },

  WEBSOCKETS: {
    /**
     * Notes
     *
     * This events are generic and should always go with a connectionType
     * which identifies the type of connection that the event is for.
     */
    AUTH_REQUESTED: `${WEBSOCKETS_CATEGORY}:AUTH_REQUESTED`,
    AUTH_SUCCESS: `${WEBSOCKETS_CATEGORY}:AUTH_SUCCESS`,
    CLOSED: `${WEBSOCKETS_CATEGORY}:CLOSED`,
    ERROR: `${WEBSOCKETS_CATEGORY}:ERROR`,

    NOTIFICATIONS: {
      NEW: `${WEBSOCKETS_CATEGORY}:${NOTIFICATIONS_SUBCATEGORY}:NEW`,
    },

    MESSAGING: {
      ENTER_CHAT: `${MESSAGING_MODULE_CATEGORY}:ENTER_CHAT`,
      MESSAGE_SEND: `${MESSAGING_MODULE_CATEGORY}:MESSAGE_SEND`,
      MESSAGE_RECEIVE: `${MESSAGING_MODULE_CATEGORY}:MESSAGE_RECEIVE`,
      CHAT_RECEIVE: `${MESSAGING_MODULE_CATEGORY}:CHAT_RECEIVE`,
    },

    LIST_DIALING: {
      CALL_STATUS_UPDATE: `${WEBSOCKETS_CATEGORY}:${LIST_DIALING_SUBCATEGORY}:CALL_STATUS_UPDATE`,
      ERROR: `${WEBSOCKETS_CATEGORY}:${LIST_DIALING_SUBCATEGORY}:ERROR`,
    },

    CALL_COPILOT: {
      START_LISTENING: `${WEBSOCKETS_CATEGORY}:${CALL_COPILOT_SUBCATEGORY}:START_LISTENING`,
      MESSAGE_RECEIVED: `${WEBSOCKETS_CATEGORY}:${CALL_COPILOT_SUBCATEGORY}:MESSAGE_RECEIVED`,
    },
  },

  LIST_DIALING: {
    LEAD_CONNECTED: `${LIST_DIALING_CATEGORY}:LEAD_CONNECTED`,
    LEADS_RUNNING_OUT: `${LIST_DIALING_CATEGORY}:LEADS_RUNNING_OUT`,
    EXIT: `${LIST_DIALING_CATEGORY}:EXIT`,
  },

  CALLING_MODULE: {
    FREQUENTLY_CHANGING_CONTEXT: {
      INPUT_VOLUME_UPDATED: `${CALLING_MODULE_CATEGORY}:${FREQUENTLY_CHANGING_CONTEXT_SUBCATEGORY}:INPUT_VOLUME_UPDATED`,
      OUTPUT_VOLUME_UPDATED: `${CALLING_MODULE_CATEGORY}:${FREQUENTLY_CHANGING_CONTEXT_SUBCATEGORY}:OUTPUT_VOLUME_UPDATED`,
      CALL_QUALITY_UPDATED: `${CALLING_MODULE_CATEGORY}:${FREQUENTLY_CHANGING_CONTEXT_SUBCATEGORY}:CALL_QUALITY_UPDATED`,
    },
    TOUR: {
      START_TOUR: `${CALLING_MODULE_CATEGORY}:${DIALER_TOUR}:START_TOUR`,
    },
  },

  ACCOUNT: {
    RELOAD: `${ACCOUNT_CATEGORY}:RELOAD`,
    RELOAD_COMPLETE: `${ACCOUNT_CATEGORY}:RELOAD_COMPLETE`,

    HISTORY: {
      RELOAD: `${ACCOUNT_CATEGORY}:${ACCOUNT_HISTORY_SUBCATEGORY}:RELOAD`,
    },

    EMAIL_TEMPLATES: {
      PROMT_BLUR: `${ACCOUNT_CATEGORY}:${EMAIL_TEMPLATES_SUBCATEGORY}:BLUR`,
      OPEN_FOLLOWUP_DRAFT: `${ACCOUNT_CATEGORY}:${EMAIL_TEMPLATES_SUBCATEGORY}:OPEN_FOLLOWUP_DRAFT`,
      ON_EMAIL_SEND: `${ACCOUNT_CATEGORY}:${EMAIL_TEMPLATES_SUBCATEGORY}:ON_EMAIL_SEND`,
    },

    DISPOSITION: {
      SUBMIT: `${ACCOUNT_CATEGORY}:${DISPOSITION_SUBCATEGORY}:SUBMIT`,
    },

    CLOSE: `${ACCOUNT_CATEGORY}:CLOSE`,
  },

  LIST_WORKSPACE: {
    GLOBAL_SEARCH: {
      OPEN: `${LIST_WORKSPACE_CATEGORY}:GLOBAL_SEARCH:OPEN`,
    },
    TABLE: {
      SCROLL_TO_COLUMN: `${LIST_WORKSPACE_CATEGORY}:${TABLE_SUBCATEGORY}:SCROLL_TO_COLUMN`,
      ACTIONS_CELL_MOUSE_ENTER: `${LIST_WORKSPACE_CATEGORY}:${TABLE_SUBCATEGORY}:ACTIONS_CELL_MOUSE_ENTER`,
      ACTIONS_CELL_MOUSE_LEAVE: `${LIST_WORKSPACE_CATEGORY}:${TABLE_SUBCATEGORY}:ACTIONS_CELL_MOUSE_LEAVE`,
    },
  },

  WIDGETS: Object.values(WIDGETS).reduce(
    (listenersMap, currentWidget) => {
      listenersMap[currentWidget] = {
        OPEN: `${WIDGETS_CATEGORY}:${currentWidget}:OPEN`,
        CLOSE: `${WIDGETS_CATEGORY}:${currentWidget}:CLOSE`,
        TOGGLE: `${WIDGETS_CATEGORY}:${currentWidget}:TOGGLE`,
        TRIGGER: `${WIDGETS_CATEGORY}:${currentWidget}:TRIGGER`,
      };

      return listenersMap;
    },
    {} as Record<
      ValueOfObjectFields<typeof WIDGETS>,
      {
        OPEN: string;
        CLOSE: string;
        TOGGLE: string;
        TRIGGER: string;
      }
    >
  ),
} as const;
